<template>
  <div class="row mt-8">
    <div class="row bg-white">
      <div class="col d-flex justify-content-between align-items-center py-3">
        <!-- Breadcrumb alineado a la izquierda -->
        <nav aria-label="breadcrumb" class="mb-0">
          <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
            <li class="breadcrumb-item">
              <a href="#"><strong>Tutoriales</strong></a>
            </li>
          </ol>
        </nav>

        <!-- Botón alineado a la derecha -->
        <button
          @click="$router.push('/').catch(() => {})"
          class="btn_regresar_tutoriales"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-arrow-left"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
            />
          </svg>
          Regresar
        </button>
      </div>
    </div>

    <div class="bg-white row text-center mb-2 mt-2">
      <div class="col">
           <button
          v-if="carpetaSeleccionada"
          class="btn btn-primary w-100 d-flex justify-content-center align-items-center position-relative" style="background-color: #033a74; margin: 0;"
          @click="volverARaiz"
        >
          <span class="position-absolute left-0 ml-3"> ← </span>
          <span>{{ carpetaSeleccionada.name }}</span>
        </button>

        <div class="row justify-content-center mb-3 mt-3">
          <div class="col-12 col-md-3">
            <div class="input-group">
              <input
                @keyup="searchCarpeta($event)"
                type="text"
                class="form-control text-center"
                placeholder="🔍 Buscar"
              />
            </div>
          </div>
        </div>

        <hr />

        <button
          class="btn btn-outline-success m-2"
          v-for="carpeta in carpetas"
          :key="carpeta.id"
          @click="mostrarSubcarpetas(carpeta)"
        >
          {{ carpeta.name }}
        </button>
      </div>
    </div>
    <div class="row bg-white mt-3">
      <div class="col-sm-6">
        <div class="tabla_estilo_tutoriales" v-if="videos.length">
          <div class="row">
            <div class="col-12 mt-3">
              <h3 class="text-center">¿Qué información necesitas?</h3>
            </div>
          </div>

          <div class="row d-flex justify-content-center">
            <div class="col-6">
              <input
                @keyup="searchVideo($event)"
                type="text"
                class="vs-input text-center"
                placeholder="🔍 Buscar"
              />
            </div>
          </div>
          <br />
          <div class="row">
            <div id="playlist-tutoriales" class="col-12">
              <table class="table table-hover">
                <tbody>
                  <tr
                    class="video-tutorial cursor-pointer"
                    @click="sendVideo(video)"
                    v-for="video in videos"
                    :key="video.id"
                  >
                    <th scope="row">
                      <img
                        class="mr-2 -ml-4 w-8 h-8"
                        src="@/assets/images/tutoriales/video.png"
                        alt=""
                      />
                    </th>
                    <td>{{ video.name }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div id="registros-tutoriales" class="row">
            <div class="col-12">
              <!-- contador de registros -->
              <!-- <p>Mostrando registros del 1 al 10 de un total de 20 registros</p> -->
              <p id="registros-tutoriales-msg"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 mt-12">
        <div class="container-video-tutoriales" v-if="videos.length">
          <iframe
            v-if="hasVideo"
            :title="videoTitle"
            :src="videoUrl"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            class="video_frame_tutoriales"
            allowfullscreen
          >
          </iframe>

          <div
            class="video_frame_tutoriales notfound-video border d-flex align-items-center justify-content-center bg-grey-light"
            v-else
          >
            <div>
              <p class="text-xl font-semibold">Sin vídeo</p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-16 h-16"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.182 16.318A4.486 4.486 0 0012.016 15a4.486 4.486 0 00-3.198 1.318M21 12a9 9 0 11-18 0 9 9 0 0118 0zM9.75 9.75c0 .414-.168.75-.375.75S9 10.164 9 9.75 9.168 9 9.375 9s.375.336.375.75zm-.375 0h.008v.015h-.008V9.75zm5.625 0c0 .414-.168.75-.375.75s-.375-.336-.375-.75.168-.75.375-.75.375.336.375.75zm-.375 0h.008v.015h-.008V9.75z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iframe: null,
      player: null,
      timeout: null,

      videos: [], // Lista que se muestra en UI
      videosApi: [], // Copia original desde API
      allTutoriales: [], // Todos los datos (carpetas y videos)
      videoList: [], // Lista actual de videos sin carpetas

      token: "",
      videoUrl: null,
      videoTitle: null,
      hasVideo: true,

      carpetaSeleccionada: null,
      carpetas: [],
      subcarpetas: [],
      historialCarpetas: [],
    };
  },

  mounted() {
    this.getApiKey();
    this.getTokenSisec();
  },

  methods: {
    getApiKey() {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (!userInfo || !userInfo.ApiKey) {
        this.$router.push("/login");
      } else {
        this.key = userInfo.ApiKey;
      }
    },

    getTokenSisec() {
      const objRequestToken = {
        strApiKey: this.key,
        strMetodo: "DameAuthToken",
      };

      this.$axios
        .post("/", objRequestToken, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        })
        .then((response) => {
          if (!response.data.error) {
            this.token = response.data.access_token;
            this.getVideos();
          } else {
            this.$vs.notify({
              title: "Error al obtener token",
              text: response.data.error_description,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Error de sistema",
            text: error,
            color: "danger",
            position: "top-right",
          });
        });
    },

    getVideos() {
      const objRequest = {
        PlatformId: 907,
        PlatformName: "Comparador",
      };

      const tokenBearer = "Bearer " + this.token;

      this.$axios
        .post(
          "https://apivalidacionriesgos.sisec.mx/api/Tutorial/GetTutorials", 
          // "https://apivalidacionriesgos.sisec.mx/api/Tutorial/GetTutorials", //PRUEBAS 
          objRequest,
          {
            headers: { Authorization: tokenBearer },
          }
        )
        .then((resp) => {
          if (resp.status === 200) {
            const tutoriales = resp.data.Tutorial;
            this.allTutoriales = tutoriales;
            this.videosApi = [...tutoriales];

            this.videoList = tutoriales.filter(
              (item) =>
                item.isFolder === false &&
                item.tutorialFolderId === "00000000-0000-0000-0000-000000000000"
            );
            this.videos = [...this.videoList];

            // Carpetas raíz
            this.carpetas = tutoriales.filter(
              (item) =>
                item.isFolder === true &&
                item.tutorialFolderId === "00000000-0000-0000-0000-000000000000"
            );

            if (this.videos.length > 0) {
              this.sendVideo(this.videos[0]);
            }
          } else {
            this.$vs.notify({
              title: "Error al obtener videos",
              text: resp.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Error",
            text: error,
            color: "danger",
            position: "top-right",
          });
        });
    },

    sendVideo(video) {
      this.videoUrl = null;
      const iframe = video.iframe;
      const idxStart = iframe.indexOf('src="');

      if (idxStart === -1) {
        this.hasVideo = false;
      } else {
        this.hasVideo = true;
        const url = iframe.slice(idxStart + 5).split('"')[0];
        this.videoUrl = url;
        this.videoTitle = video.name;
      }
    },

    searchVideo(event) {
      const word = event.target.value.toLowerCase();
      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        const base = this.carpetaSeleccionada
          ? this.allTutoriales.filter(
              (item) =>
                !item.isFolder &&
                item.tutorialFolderId === this.carpetaSeleccionada.id
            )
          : this.videoList;

        this.videos = base.filter((item) =>
          item.name.toLowerCase().includes(word)
        );
      }, 750);
    },

    mostrarSubcarpetas(carpeta) {
      if (this.carpetaSeleccionada) {
        // Guardar la carpeta actual en el historial antes de cambiar
        this.historialCarpetas.push(this.carpetaSeleccionada);
      }

      this.carpetaSeleccionada = carpeta;

      this.carpetas = this.allTutoriales.filter(
        (item) => item.isFolder && item.tutorialFolderId === carpeta.id
      );

      this.videos = this.allTutoriales.filter(
        (item) => !item.isFolder && item.tutorialFolderId === carpeta.id
      );

      this.videoList = [...this.videos];
    },
    volverARaiz() {
      if (this.historialCarpetas.length > 0) {
        // Retroceder un nivel
        this.carpetaSeleccionada = this.historialCarpetas.pop();

        this.carpetas = this.allTutoriales.filter(
          (item) =>
            item.isFolder &&
            item.tutorialFolderId === this.carpetaSeleccionada.id
        );

        this.videos = this.allTutoriales.filter(
          (item) =>
            !item.isFolder &&
            item.tutorialFolderId === this.carpetaSeleccionada.id
        );
      } else {
        // Si no hay historial, volvemos a la raíz
        this.carpetaSeleccionada = null;

        this.carpetas = this.allTutoriales.filter(
          (item) =>
            item.isFolder &&
            item.tutorialFolderId === "00000000-0000-0000-0000-000000000000"
        );

        this.videos = this.allTutoriales.filter(
          (item) =>
            !item.isFolder &&
            item.tutorialFolderId === "00000000-0000-0000-0000-000000000000"
        );
      }

      this.videoList = [...this.videos];
    },
    searchCarpeta(event) {
      const termino = event.target.value.toLowerCase();
      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        const listaCompleta = this.carpetaSeleccionada
          ? this.allTutoriales.filter(
              (item) =>
                item.isFolder &&
                item.tutorialFolderId === this.carpetaSeleccionada.id
            )
          : this.carpetas;

        // Si el término está vacío, restauramos la lista completa
        if (termino === "") {
          this.carpetas = this.allTutoriales.filter(
            (item) =>
              item.isFolder &&
              item.tutorialFolderId === "00000000-0000-0000-0000-000000000000"
          ); // Restauramos la lista completa de carpetas
        } else {
          // De lo contrario, filtramos según el término
          this.carpetas = listaCompleta.filter((item) =>
            item.name.toLowerCase().includes(termino)
          );
        }
      }, 750);
    },
  },
};
</script>

<style>
.alineado_btn_tutoriales {
  display: flex;
  flex-direction: row;
  justify-content: right;
}
.btn_regresar_tutoriales {
  width: 150px;
  border-radius: 20px;
  background-color: #fff;
  color: #033a74;
  height: 40px;
  border: none;
  font-size: 12px;
  font-weight: 500;
}
.container-video-tutoriales {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
}
.video_frame_tutoriales {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.video_frame_tutoriales.notfound-video {
  text-align: center;
}
.control-video-tutoriales {
  background-color: #fafcff;
}
.control-video-tutoriales button {
  border: none;
  background: none;
  color: gray;
  margin: 0 5px;
}
.tabla_estilo_tutoriales {
  background-color: #fff;
}
.titulo_video_tutoriales {
  background-color: aliceblue;
  color: #12629a;
  font-weight: 600;
  font-size: 1.2rem;
  border-bottom: 3px solid #12629a;
  padding: 1rem 1rem 0.5rem;
}
#playlist-tutoriales table {
  margin-bottom: 0;
}
#playlist-tutoriales table tbody {
  border-top: 2px solid #f7f9fd;
  border-bottom: 2px solid #f7f9fd;
}
#playlist-tutoriales table tbody tr td {
  color: #12629a;
  font-size: 1.2rem;
}
#paginacion-tutoriales {
  background-color: #f1f4ff;
  padding: 1rem;
}
#paginacion-tutoriales .page-link {
  color: #4ed176;
  font-weight: 500;
}
#paginacion-tutoriales .page-link.active {
  background-color: #4ed176;
  border-color: #4ed176;
  color: white;
}
#paginacion-tutoriales .page-link.disabled {
  background-color: #c4dfca;
  border-color: #dee2e6;
  color: #4ed176;
}
#paginacion-tutoriales .page-link:focus {
  box-shadow: 0 0 0 0.25rem rgba(35, 209, 29, 0.479);
}
#registros-tutoriales {
  background-color: #f1f4ff;
  padding: 1rem;
  text-align: center;
}
</style>
